/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-10T15:01:42.747
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseOnline,
	listRentHouseOnlineInit,
	listRentHouseOnlineByAuthorizations,
	deleteRentHouseOnline
	
} from '@api/rentmanage/RentHouseOnline';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
		//是否编辑状态查看
		edit:true
	},

	actions: {
		listRentHouseOnline({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseOnline(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseOnlineByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseOnlineByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseOnlineInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseOnlineInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseOnline({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseOnline({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
